import React, { FC, useEffect } from 'react';
import { SCUICollapsiblePaper } from '../../../../../atomic/molecules';
import { BillingCommand } from '../../../../../services/command';
import { Grid, Fade, LinearProgress } from '@mui/material';
import Swal from 'sweetalert2';

import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import './SCUIBillingGoalDrawerContent.scss';

export const SCUIBillingGoalDrawerContent: FC<{
    id: number;
    onClose?: any;
}> = ({ id, onClose }) => {
    const [loading, setLoading] = React.useState(true);
    const [sendInvoice, setSendInvoice] = React.useState<any>();
    const [sendInvoiceLog, setSendInvoiceLog] = React.useState<any>();
    const { t } = useTranslation();

    useEffect(() => {
        GetBillingService();
    }, [id]);

    const getParams = (getBillingInformationType: number) => {
        let params: any = {};
        params.referenceID = id;
        params.getBillingInformationType = getBillingInformationType;
        return params;
    };

    const GetBillingService = async () => {
        let sendInvoiceParams: any = getParams(5);
        let sendInvoiceLogParams: any = getParams(6);

        BillingCommand.PostGetBillingInformation(sendInvoiceParams).then((res: any) => {
            setLoading(false);
            setSendInvoice(res.data);
        });
        BillingCommand.PostGetBillingInformation(sendInvoiceLogParams).then((res: any) => {
            setLoading(false);
            setSendInvoiceLog(res.data);
        });
    };
    function handleCopy(id: any) {
        let copyText = document.getElementById(id)?.innerText;
        if (copyText) {
            navigator.clipboard.writeText(copyText);
            Swal.fire({
                icon: 'success',
                title: t('general.copied'),
                showConfirmButton: false,
                timer: 1500,
            });
        }
    }
    return (
        <Grid className="billing-goal-drawer">
            <Grid className="billing-goal-drawer-header" container sx={{ paddingTop: '2rem' }}>
                <Grid
                    className="billing-goal-drawer-title"
                    sx={{ paddingLeft: '1rem' }}
                    size={{
                        md: 11.5,
                        xs: 11.5,
                        lg: 11.5,
                    }}
                >
                    <h1 className="headtxt">
                        {t('general.shippingID')}: {id}
                    </h1>
                </Grid>

                <Grid
                    className="billing-goal-drawer-close"
                    size={{
                        md: 0.5,
                        xs: 0.5,
                        lg: 0.5,
                    }}
                >
                    <CloseIcon
                        className="svg_icons billing-goal-drawer-close-button"
                        onClick={onClose}
                    />
                </Grid>
            </Grid>
            {!(sendInvoice && sendInvoiceLog) && (
                <Typography className="billing-goal-drawer-not-found" variant="h4" sx={{ m: 5 }}>
                    {t('general.notFound')}{' '}
                </Typography>
            )}
            <Fade in={loading}>
                <LinearProgress className="billing-goal-drawer-loading" />
            </Fade>
            <Grid className="billing-goal-drawer-content" sx={{ margin: '2rem' }}>
                {sendInvoice && (
                    <SCUICollapsiblePaper
                        iconTooltip={t('general.copyToClipboard')}
                        icon={'fi-rr-copy'}
                        iconOnClick={() => handleCopy('sendInvoice')}
                        paperText={'SendInvoice'}
                        open={false}
                        withoutMargin
                        changeColorWhenOpen
                    >
                        <pre id="sendInvoice" className="jsonViewDiv">
                            {JSON.stringify(JSON.parse(sendInvoice), null, 2)}
                        </pre>
                    </SCUICollapsiblePaper>
                )}
                {sendInvoiceLog && (
                    <SCUICollapsiblePaper
                        iconTooltip={t('general.copyToClipboard')}
                        icon={'fi-rr-copy'}
                        iconOnClick={() => handleCopy('sendInvoiceLog')}
                        paperText={'SendInvoiceLog'}
                        open={false}
                        withoutMargin
                        changeColorWhenOpen
                    >
                        <pre id="sendInvoiceLog" className="jsonViewDiv">
                            {JSON.stringify(JSON.parse(sendInvoiceLog), null, 2)}
                        </pre>
                    </SCUICollapsiblePaper>
                )}
            </Grid>
        </Grid>
    );
};
